import { render, staticRenderFns } from "./GroupMemberForm.vue?vue&type=template&id=008d76c7&scoped=true"
import script from "./GroupMemberForm.vue?vue&type=script&lang=js"
export * from "./GroupMemberForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "008d76c7",
  null
  
)

export default component.exports